"use client";

import { useEffect } from "react";

/**
 * Slide-up on scroll. Adds `.is-visible` to every `.fp-reveal` / `.fp-stagger`
 * element once it enters the viewport (animation itself lives in the CSS).
 */
export default function FpReveal() {
  useEffect(() => {
    const els = document.querySelectorAll<HTMLElement>(".fp-reveal, .fp-stagger");

    if (typeof IntersectionObserver === "undefined") {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target); // animate once
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return null;
}
